import { enumElementDrawStates, kCheckBoxSize, kWhite } from "../constants";
import { QToggleBox } from "./QToggleBox";
import { ThicknessAdjuster } from "../utils/ThicknessAdjuster";
import { Globals } from "./Globals.js";

export class QCheckbox extends QToggleBox {
  constructor() {
    super();
  }

  InitCheckbox() {
    this.InitToggleBox(null);
    this.fIndeterminate = false;
  }

  GetCursor() {
    return "pointer";
  }

  RenderButton(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");
    ctx.save();

    var thickness = 1;
    ctx.lineWidth = thickness;

    ctx.textBaseline = "middle";
    ctx.textAlign = "center";

    var thickAdj = ThicknessAdjuster(thickness);
    var sx = this.fHorzOffset + thickAdj;
    var sy = this.fVertOffset + 2;
    var sw = kCheckBoxSize;
    var sh = kCheckBoxSize;

    var drawState = this.GetDrawState();
    var isPressed = drawState === enumElementDrawStates.MouseDown;
    var isHover = drawState === enumElementDrawStates.Hover;

    var fillStyle = this.fUIColors.GetPagingBlueColor();

    var isChecked = this.IsChecked();

    if (isHover || isPressed) {
      ctx.shadowBlur = isHover ? 1 : 2;
      ctx.shadowColor = fillStyle;
    }

    ctx.fillStyle = isChecked
      ? this.fUIColors.GetPagingBlueColor()
      : this.fUIColors.GetTextEditFillColor();
    ctx.strokeStyle = isChecked
      ? this.fUIColors.GetPagingBlueColor()
      : Globals._themeMode.text.header;

    if (drawState === enumElementDrawStates.Disabled) {
      ctx.fillStyle = this.fUIColors.GetDisabledTextColor();
      ctx.strokeStyle = this.fUIColors.GetDisabledTextColor();
      ctx.globalAlpha = 0.7;
    }

    var x0 = sx;
    var y0 = sy;
    var x1 = sx + sw;
    var y1 = sy + sh;

    var r = 1;

    var w = x1 - x0;
    var h = y1 - y0;
    if (r > w / 2) r = w / 2;
    if (r > h / 2) r = h / 2;

    ctx.beginPath();
    ctx.moveTo(x1 - r, y0);
    ctx.quadraticCurveTo(x1, y0, x1, y0 + r);
    ctx.lineTo(x1, y1 - r);
    ctx.quadraticCurveTo(x1, y1, x1 - r, y1);
    ctx.lineTo(x0 + r, y1);
    ctx.quadraticCurveTo(x0, y1, x0, y1 - r);
    ctx.lineTo(x0, y0 + r);
    ctx.quadraticCurveTo(x0, y0, x0 + r, y0);
    ctx.closePath();
    ctx.stroke();
    if (isChecked) ctx.fill();

    ctx.globalAlpha = 1;
    if (this.IsIndeterminate()) {
      ctx.beginPath();
      ctx.moveTo(sx + 3, sy + 3);
      ctx.lineTo(sx + sw - 3, sy + 3);
      ctx.lineTo(sx + sw - 3, sy + sh - 3);
      ctx.lineTo(sx + 3, sy + sh - 3);
      ctx.lineTo(sx + 3, sy + 3);
      ctx.closePath();
      ctx.fillStyle = fillStyle;
      ctx.fill();
    } else if (isChecked) {
      ctx.strokeStyle = kWhite;
      ctx.lineWidth = 1.5;
      ctx.beginPath();
      ctx.moveTo(sx + sw - 1.5, sy + 3);
      ctx.lineTo(sx + 5, sy + sh - 3);
      ctx.lineTo(sx + 1.5, sy + sh - 6);
      ctx.stroke();
    }

    ctx.shadowBlur = 0;
    ctx.restore();
  }
}
